import React, { useState } from "react";

import { css } from "@emotion/css";
import ToggleBtn from "../../../img/png/tech/toggle-button.png";
import ToggleHair from "../../../img/png/tech/toggle-hair.png";
import ToggleFace from "../../../img/png/tech/toggle-face.png";
import ToggleFacial from "../../../img/png/tech/toggle-facial.png";
import Phone from "../../../img/png/tech/phone.png";
import Specs from "../../../img/png/tech/specs.png";
import SpecsTablet from "../../../img/png/tech/specs-tablet.png";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import Clickable from "../../../components/Clickable";
import { useI18n } from "../../../i18n";

const Face = () => {
  const { t } = useI18n();
  const [active, setActive] = useState(0);

  return (
    <div className={style.container}>
      <h2 className="fa-bg">FA</h2>
      <h2 className="ce-bg">CE</h2>
      <div className="wrapper">
        <h2>{t("tech_face_config")}</h2>
        <div className="content">
          <img src={Phone} alt="" className="phone" />
          <div className="video-wrapper">
            <video autoPlay loop muted playsInline webkit-playsinline>
              <source
                src="/videos/face_configuration_and_type_for_technology_page.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <img src={Specs} alt="" className="specs desktop" />
          <img src={SpecsTablet} alt="" className="specs tablet" />
          <div className="items-wrapper">
            <h3>{t("tech_face_your")}</h3>
            <h4>{t("tech_face_shape")}</h4>
            <div className="items">
              <div className={`face ${active === 1 ? "active" : "inactive"}`}>
                <img src={ToggleFace} alt={t("tech_face_alt_face")} className="title" />
                <span className="text-wrapper">
                  <p>
                    {t("tech_face_traits")}
                  </p>
                </span>
                <Clickable onClick={() => setActive(active === 1 ? 0 : 1)}>
                  <img src={ToggleBtn} alt="" className="toggle" />
                </Clickable>
              </div>
              <div className={`hair ${active === 2 ? "active" : "inactive"}`}>
                <img src={ToggleHair} alt={t("tech_face_alt_hair")} className="title" />
                <span className="text-wrapper">
                  <p>
                    {t("tech_face_hair")}
                  </p>
                </span>
                <Clickable onClick={() => setActive(active === 2 ? 0 : 2)}>
                  <img src={ToggleBtn} alt="" className="toggle" />
                </Clickable>
              </div>
              <div className={`facial ${active === 3 ? "active" : "inactive"}`}>
                <img
                  src={ToggleFacial}
                  alt={t("tech_face_alt_feature")}
                  className="title"
                />
                <span className="text-wrapper">
                  <p>
                    {t("tech_face_vibe")}
                  </p>
                </span>
                <Clickable onClick={() => setActive(active === 3 ? 0 : 3)}>
                  <img src={ToggleBtn} alt="" className="toggle" />
                </Clickable>
              </div>
            </div>
          </div>
        </div>
        <p className="text-bottom">
          {t("tech_face_body")}
        </p>
      </div>
    </div>
  );
};

const style = {
  container: css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flexWrap: "nowrap",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "auto",
    position: "relative",
    background:
      "linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.20) 12.8%, #6643FF 97.86%)",
    overflow: "hidden",
    paddingTop: 50,
    paddingBottom: 100,

    ".desktop": {
      display: 'block'
    },
    ".tablet": {
      display: 'none'
    },
    ".fa-bg, .ce-bg": {
      color: "#000",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 362.805,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "420px",
      letterSpacing: "-29.024px",
      textTransform: "uppercase",
      bottom: 650,
      position: "absolute",
      zIndex: 0,
    },
    ".fa-bg,": {
      left: 0,
      right: 1000,
    },

    ".ce-bg": {
      right: 0,
      left: 900,
    },
    ".wrapper": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",

      ".content": {
        position: "relative",
        marginTop: -200,
        zIndex: 1,
      },
      ".video-wrapper": {
        top: 380,
        width: 892,
        height: 604,
        position: "absolute",
        background:
          "linear-gradient(0deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%), linear-gradient(0deg, rgba(103, 68, 255, 0.05) 0%, rgba(103, 68, 255, 0.05) 100%), linear-gradient(0deg, rgba(103, 68, 255, 0.40) 0%, rgba(103, 68, 255, 0.40) 100%), linear-gradient(0deg, rgba(0, 148, 255, 0.05) 0%, rgba(0, 148, 255, 0.05) 100%)",
        backgroundBlendMode: "plus-lighter, color, overlay, overlay",
        boxShadow: "0px 0px 70.1px 0px rgba(64, 78, 252, 0.50) inset",
        borderRadius: 126,
        zIndex: 1,
        overflow: "hidden",

        video: {
          height: "100%",
        },
      },

      h2: {
        color: "#000",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 84,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "98px",
        textTransform: "uppercase",
        marginBottom: 62,
        maxWidth: 1136,
      },

      ".text-bottom": {
        marginTop: -50,
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Inter",
        fontSize: 18,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: 0.36,
        width: 578,
      },
      ".specs": {
        position: 'absolute',
        top: 570,
        right: 60,
        zIndex: 1,
      },
      ".phone": {
        width: 1084,
        height: 1791,
        marginLeft: 120,
        zIndex: 1,
      },
      ".items-wrapper": {
        borderRadius: 100,
        border: "1.15px solid #FFF",
        backdropFilter: "blur(11.380048751831055px)",
        padding: 21,
        zIndex: 1,
        position: "absolute",
        bottom: 160,
        left: 0,
        right: 0,
        margin: "auto",
        maxWidth: 580,

        h3: {
          color: "#fff",
          textAlign: "center",
          fontFamily: "Syne",
          fontSize: 54.551,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "63.151px",
          textTransform: "uppercase",
        },
        h4: {
          color: "#fff",
          textAlign: "center",
          fontFamily: "Syne",
          fontSize: 26.18,
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "30.307px",
          letterSpacing: 0.838,
          marginBottom: 23,
        },
        p: {
          color: "#000",
          fontFamily: "Inter",
          fontSize: 15.135,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "25px",
          width: 578,
        },
        ".items": {
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",
          gap: 18,
          borderRadius: 68.97,
          border: "1.15px solid #FFF",
          background: "rgba(255, 255, 255, 0.20)",
          backdropFilter: "blur(11.380048751831055px)",
          padding: 20,

          div: {
            transition: "all 2s",
            borderRadius: 48.279,
            border: "0.649px solid rgba(255, 255, 255, 0.60)",
            background: "rgba(255, 255, 255, 0.55)",
            backdropFilter: "blur(7.644175052642822px)",
            overflow: "hidden",
            padding: 18,
            display: "flex",
            width: 497.629,
            justifyContent: "space-between",
            alignItems: "flex-start",
            height: 70,
            gap: 18,

            "&.face": {
              p: {
                width: 190,
              },
            },
            "&.hair": {
              p: {
                width: 109,
              },
            },
            "&.facial": {
              p: {
                width: 120,
              },
            },

            ".text-wrapper": {
              height: 80,
              overflow: "hidden",
              transition: "all 2s",
              marginRight: "auto",
            },

            "&.active": {
              height: "auto",

              ".toggle": {
                transform: "rotate(180deg)",
              },
              ".text-wrapper": {
                height: "auto",
              },
            },
          },
        },
      },
    },

    [desktop]: {
      paddingTop: 20,
      paddingBottom: 143,

      ".fa-bg, .ce-bg": {
        fontSize: 255.552,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '295.839px',
        letterSpacing: '-20.444px',
        bottom: 350,
        position: "absolute",
        zIndex: 0,
      },
      ".fa-bg,": {
        left: 0,
        right: 700,
      },

      ".ce-bg": {
        right: 0,
        left: 700,
      },
      ".wrapper": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",

        ".content": {
          position: "relative",
          marginTop: -200,
          zIndex: 1,
        },
        ".video-wrapper": {
          top: 270,
          width: 628.306,
          height: 425.445,
          borderRadius: 126,
        },

        h2: {
          fontSize: 70,
          lineHeight: "80px",
          marginBottom: 63,
          maxWidth: 836,
        },

        ".text-bottom": {
          marginTop: -50,
          color: "#FFF",
          textAlign: 'center',
          fontFamily: 'Inter',
          fontSize: 18,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 0.36,
          width: 797,
        },
        ".specs": {
          position: 'absolute',
          top: 350,
          right: 25,
          zIndex: 1,
          width: 341,
          height: 260
        },
        ".phone": {
          width: 800,
          height: 1300,
          marginLeft: 100,
        },
        ".items-wrapper": {
          borderRadius: 100,
          padding: 14,
          bottom: 120,
          maxWidth: 412 ,

          h3: {
            color: "#fff",
            fontSize: 38.008,
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '44px'
          },
          h4: {
            color: "#fff",
            fontSize: 18.24,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '21.116px',
            letterSpacing: 0.584,
            marginBottom: 16,
          },
          p: {
            fontSize: 10.5,
            fontWeight: 400,
            lineHeight: "19px",
            letterSpacing: 0.211,
          },
          ".items": {
            padding: 18,
            gap: 14,
            borderRadius: 48.97,

            div: {
              borderRadius: 33.638,
              padding: 12,
              width: 346,
              height: 60,
              gap: 14,

              "&.face": {
                p: {
                  width: 133,
                },
              },
              "&.hair": {
                p: {
                  width: 76,
                },
              },
              "&.facial": {
                p: {
                  width: 83,
                },
              },
              '.toggle, .title': {
                height: 56,
                width: 'auto'
              },

              ".text-wrapper": {
                height: 60,
              },
            },
          },
        },
      },
    },
    [laptop]: {
      paddingTop: 39,
      paddingBottom: 109,

      ".fa-bg, .ce-bg": {
        fontSize: 154,
        lineHeight: '178px',
        letterSpacing: '-12px',
        bottom: 450,
        position: "absolute",
        zIndex: 0,
      },
      ".fa-bg,": {
        left: 0,
        right: 700,
      },

      ".ce-bg": {
        right: 0,
        left: 700,
      },
      ".wrapper": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",

        ".content": {
          position: "relative",
          marginTop: -200,
          zIndex: 1,
        },
        ".video-wrapper": {
          top: 270,
          left: 100,
          width: 455,
          height: 308,
          borderRadius: 64,
        },

        h2: {
          fontSize: 60,
          lineHeight: "58px",
          marginBottom: 78,
          maxWidth: 661,
        },

        ".text-bottom": {
          marginTop: -50,
          color: "#FFF",
          textAlign: 'center',
          fontFamily: 'Inter',
          fontSize: 18,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 0.36,
          width: 578,
        },
        ".specs": {
          position: 'absolute',
          top: 330,
          right: 40,
          zIndex: 1,
          width: 280,
          height: 'auto'
        },
        ".phone": {
          width: 740,
          height: 1200,
          marginLeft: 90,
        },
        ".items-wrapper": {
          borderRadius: 66,
          padding: 14,
          bottom: 130,
          maxWidth: 393 ,

          h3: {
            color: "#fff",
            fontSize: 36,
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '42px'
          },
          h4: {
            color: "#fff",
            fontSize: 17,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '20px',
            letterSpacing: 0.584,
            marginBottom: 16,
          },
          p: {
            fontSize: 10,
            fontWeight: 400,
            lineHeight: "18.5px",
            letterSpacing: 0.211,
          },
          ".items": {
            padding: 18,
            gap: 14,
            borderRadius: 48.97,

            div: {
              borderRadius: 33.638,
              padding: 12,
              width: 330,
              height: 48,
              gap: 11,

              "&.face": {
                p: {
                  width: 127,
                },
              },
              "&.hair": {
                p: {
                  width: 73,
                },
              },
              "&.facial": {
                p: {
                  width: 80,
                },
              },
              '.toggle, .title': {
                height: 43,
                width: 'auto'
              },

              ".text-wrapper": {
                height: 60,
              },
            },
          },
        },
      },
    },
    [tablet]: {
      background:
      "linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.20) 52.8%, #6643FF 77.86%)",
      paddingTop: 46,
      paddingBottom: 76,

      ".desktop": {
        display: 'none'
      },
      ".tablet": {
        display: 'block'
      },
      ".fa-bg, .ce-bg": {
        display: 'none',
      },
      ".wrapper": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",

        ".content": {
          position: "relative",
          marginTop: -80,
          zIndex: 1,
        },
        ".video-wrapper": {
          top: 210,
          left: 70,
          width: 300,
          height: 210,
          borderRadius: 64,
        },

        h2: {
          fontSize: 32,
          lineHeight: "38px",
          marginBottom: 24,
          maxWidth: 332,
        },

        ".text-bottom": {
          marginTop: 0,
          fontSize: 14,
          letterSpacing: 0.28,
          width: 319,
        },
        ".specs": {
          position: 'absolute',
          top: 240,
          right: 93,
          width: 155,
          height: 'auto'
        },
        ".phone": {
          width: 'auto',
          height: 820,
          marginLeft: 60,
        },
        ".items-wrapper": {
          borderRadius: 44,
          padding: 8,
          bottom: 90,
          maxWidth: 253 ,

          h3: {
            fontSize: 24,
            lineHeight: '28px'
          },
          h4: {
            fontSize: 11.5,
            lineHeight: '13.5px',
            letterSpacing: 0.372,
            marginBottom: 16,
          },
          p: {
            fontSize: 8,
            fontWeight: 400,
            lineHeight: "12px",
            letterSpacing: 0.16,
          },
          ".items": {
            padding: 18,
            gap: 8,
            borderRadius: 28,

            div: {
              borderRadius: 20,
              padding: 8,
              width: 227,
              height: 28,
              gap: 8,

              "&.face": {
                p: {
                  width: 90,
                },
              },
              "&.hair": {
                p: {
                  width: 58,
                },
              },
              "&.facial": {
                p: {
                  width: 53,
                },
              },
              '.toggle, .title': {
                height: 31,
              },

              ".text-wrapper": {
                height: 38,
              },
            },
          },
        },
      },
    },
  }),
};

export default Face;
